import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CSSReset } from '@chakra-ui/core';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { StoreProvider } from './store';

ReactDOM.render(
  <StoreProvider>
    <ThemeProvider>
      <BrowserRouter basename="/triventi">
        <CSSReset />
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </StoreProvider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
